import { Injectable } from '@angular/core';
import {Http, Headers} from '@angular/http';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Rx';
import {Service} from "../shared/services/service";
import {Funcoes} from "../funcoes";

@Injectable()
export class UsuariosCargosService extends Service{

  protected url: string = this.dominio+"/adm/usuarios-cargos/";

  constructor(protected http: Http, protected func: Funcoes) {
    super();
  }

  // retorna todas as acoes
  getAcoes(){

    let headers = this.getHeaderLogado();

    return this.http.get(this.dominio+'/adm/sistema/acoes/', {headers})
      .map(res => {
        let json = res.json();
        if(json.Success){
          this.trataSucesso(res);
        }else{
          this.trataErro(json);
        }
        return json;
      });

  }

  // retorna o cargo com suas ações e privilegios no sistema
  getAcoesByIdCargo(id_cargo){

    let headers = this.getHeaderLogado();

    return this.http.get(this.dominio+'/adm/usuarios-cargos/'+id_cargo+'/?relations=["privilegiosAcoes"]', {headers})
      .map(res => {
        let json = res.json();
        if(json.Success){
          this.trataSucesso(res);
        }else{
          this.trataErro(json);
        }
        return json;
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/usuarios-cargos/usuarios-cargos.service.ts